import React, { useRef } from 'react'
import { useDataContext } from '../../Context/DataContext'
import { useGSAP } from '@gsap/react';   // 👈 Add GSAP imports
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

// Register the ScrollTrigger plugin once
gsap.registerPlugin(ScrollTrigger);

export const Internship = () => {
    const { internship } = useDataContext();

    // --- GSAP Animation Refs ---
    const sectionRef = useRef(null);
    const titleRef = useRef(null);

    useGSAP(() => {
        // --- Timeline for the main title reveal ---
        // gsap.from(titleRef.current, {
        //     y: 50,
        //     opacity: 0,
        //     delay: 1.5,
        //     filter: "blur(10px)",
        //     duration: 0.8,
        //     ease: "power2.out",
        //     scrollTrigger: {
        //         trigger: sectionRef.current,
        //         start: 'top 85%',
        //         // Play animation on scroll down, Restart animation on scroll up
        //         toggleActions: 'play none restart reverse',
        //     }
        // });

        // // --- Animate each Internship Item ---
        // gsap.utils.toArray(".internship-item").forEach((item) => {

        //     // Animate the image block (from the left)
        //     gsap.from(item.querySelector('.internship-visual'), {
        //         x: -100,
        //         opacity: 0,
        //         delay: 1.5,
        //         filter: "blur(10px)",
        //         duration: 1.2,
        //         ease: "power2.out",
        //         scrollTrigger: {
        //             trigger: item,
        //             start: 'top 75%', // Start when the item is 75% down the viewport
        //             toggleActions: 'play none restart reverse',
        //         }
        //     });

        //     // Animate the text/info block (from the right)
        //     gsap.from(item.querySelector('.internship-info'), {
        //         x: 100,
        //         opacity: 0,
        //         delay: 1.5,
        //         filter: "blur(10px)",
        //         duration: 1.2,
        //         ease: "power2.out",
        //         scrollTrigger: {
        //             trigger: item,
        //             start: 'top 75%', // Use the same trigger point
        //             toggleActions: 'play none restart reverse',
        //         }
        //     });
        // });

        gsap.from(titleRef.current, {
            y: 50,
            opacity: 0,
            delay: 1.5,
            filter: "blur(10px)",
            duration: 0.8,
            ease: "power2.out",
            scrollTrigger: {
                trigger: sectionRef.current,
                start: 'top 80%',
                // Play animation on scroll down, Restart animation on scroll up
                toggleActions: 'play none none reverse',
            }
        });

        // --- Animate each Internship Item ---
        gsap.utils.toArray(".internship-item").forEach((item, index) => {
            const isOdd = 2 % index !== 0; // Determines the side for alternating effect

            // Animate the main internship title (e.g., "E-Commerce Store")
            gsap.from(item.querySelector('.internship-info img'), {
                y: -20,
                opacity: 0,
                delay: 1.5,
                filter: "blur(10px)",
                duration: 0.8,
                ease: "power2.out",
                scrollTrigger: {
                    trigger: item,
                    start: 'top 80%',
                    toggleActions: 'play none none reverse',
                }
            });

            // Animate the image and info block simultaneously (Zipper Effect)
            gsap.from(item.querySelectorAll('.internship-visual, .internship-info h3, .internship-info p'), {
                opacity: 0,
                delay: 1.5,
                filter: "blur(10px)",
                duration: 1.2,
                ease: "power2.out",
                // Slide direction depends on if the index is odd or even
                x: isOdd ? 100 : -100,
                stagger: 0.5, // Slight stagger between the visual and info block
                scrollTrigger: {
                    trigger: item,
                    start: 'top 80%',
                    toggleActions: 'play none none reverse',
                }
            });
        });

    }, { scope: sectionRef });

    return (
        <>
            <div ref={sectionRef} className='text-center text-surface lg:text-left pb-5 relative overflow-hidden'>
                <div className='md:px-20 xl:px-32'>
                    <div className='container mx-auto py-8 px-9'>
                        {/* Internship */}
                        <p ref={titleRef} className='font-pockota font-bold text-2xl sm:text-3xl md:text-4xl text-y-col'>Experience</p>
                    </div>
                </div>
                {internship.map((internship, index) => (
                    <div className='internship-item md:px-20 xl:px-32 pattern2 bg-[length:33.22%_99.8%] sm:bg-[length:19.938%_99.8%] lg:bg-[length:9.99%_99.8%]' key={index}>
                        <div className='container mx-auto py-10 px-9'>
                            <div className="flex flex-col lg:flex-row items-center pt-10 lg:py-10 gap-5 lg:gap-10 dark:text-tx-col">
                                <div className={`internship-visual lg:w-1/2 w-full overflow-hidden rounded-lg ${internship.class || null}`}>
                                    <img className='w-full h-full' src={internship.img} alt={`${internship.alt}'s Landing Page`} />
                                </div>
                                <div className='internship-info lg:w-1/2 flex flex-col items-start gap-6'>
                                    <img className={`${internship.height || 'h-16'}`} src={internship.logo} alt={internship.alt} title={internship.alt} />
                                    <h3 className='text-sm sm:text-base lg:text-lg font-medium'>{internship.duration}</h3>
                                    <p className='text-sm sm:text-base lg:text-lg font-light text-justify'>{internship.p1}</p>
                                    <p className='text-sm sm:text-base lg:text-lg font-light text-justify'>{internship.p2}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </>
    )
}